const VERSION = "@turnkey/sdk-browser@5.2.3";

export { VERSION };
//# sourceMappingURL=version.mjs.map
